export default __webpack_public_path__ + "static/MMD-logo-03-5d32d7fdb01ae6a5fb2b59369d4042a5.png";